import { useContext } from 'react'

import { Globals } from '@h2/globals'
import { VIEW_MODE_MANAGEMENT, VIEW_MODE_BASIC } from '@h2/common/constants'

import { Home } from './home'
import { Explorer } from './explorer'
import { Navigator } from './navigator'
import { EarlyLearning } from './earlyLearning'

const modes = {
  [VIEW_MODE_MANAGEMENT]: Navigator,
  [VIEW_MODE_BASIC]: Explorer
}
const Dashboard = () => {
  const { isLoggedIn, userProfile, viewMode, isEarlyLearnerMode } = useContext(Globals)

  if (!isLoggedIn) {
    return <Home />
  }

  if (isEarlyLearnerMode) {
    return <EarlyLearning />
  }

  if (userProfile?.hasManager) {
    const Dash = modes[viewMode]

    return <Dash />
  }

  return <Explorer />
}

export { Dashboard }
